module.exports = __webpack_public_path__ + "img/mutation.fc85cb6e.png";